import { CLEAR_ACCOUNT_TYPE, SELECT_ACCOUNT_TYPE } from '../../../common/constants/reduxConstants'
import { submitRegisterProviderForm } from '../../../common/http/data/providers'

export const submitRegisterProvider = (data: any) => {
  const request = submitRegisterProviderForm(data)

  return (_: any) => {
    return new Promise(function (resolve, reject) {
      request.then(
        (registrationReturn) => {
          resolve(registrationReturn)
        },
        (error) => {
          reject(error)
        },
      )
    })
  }
}

export const selectAccountType = (type: any) => {
  return {
    type: SELECT_ACCOUNT_TYPE,
    payload: type,
  }
}

export const clearAccountType = () => {
  return {
    type: CLEAR_ACCOUNT_TYPE,
  }
}
